import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Description from "@components/CustomTypography/Description/Description"
import Iframe from "@components/CustomTypography/Iframe/Iframe"
import Separator from "@components/CustomTypography/Separator/Separator"
import Title from "@components/CustomTypography/Title/Title"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./OpenApplicationContentSection.module.scss"

type Props = {
	data: AdvancedSideAssetMainContent
}

const OpenApplicationContentSection = (props: Props) => {
	const mainContent = props.data
	return (
		<ContainerWrapper>
			<Separator size={128}>
				<Separator size={16}>
					{mainContent.preview && <Iframe {...mainContent.preview} />}
				</Separator>
				<Separator />
				<div className={`${styles.contentContainer}`}>
					<Title content={mainContent.title} center />
					<Separator />
					<Description content={mainContent.content} />
				</div>
			</Separator>
		</ContainerWrapper>
	)
}

export default OpenApplicationContentSection
